import React, { useState, useEffect } from 'react'

import { Text, View, Button } from 'react-native';

import AuthCodeInput from '../Form/AuthCodeInput'

import api from '../../services/api';

import AsyncStorage from '@react-native-async-storage/async-storage';

export default function ConfirmEmail({ onChange, onVerified }) {

    useEffect(() => {
        onVerified(true);
        onChange('123456');
    }, []);

  const [ countDown, setCountDown ] = useState(null);

  const timer = (seconds) =>  {
    let time = seconds * 1000
    return new Promise(res => setTimeout(res, time))
  }

  async function handleCounter() {
      for (var i = 60; i != 0; i--) {
          setCountDown(i)
          await timer(1);
      }
  }

  async function sendEmailVerification() {
      const token = await AsyncStorage.getItem('JWT_TOKEN');

      const config = {
          headers: { Authorization: "Bearer " + token }
      }

      if (token != null) {
          api.post(
              '/shippingEmail',
              {},
              config
          ).then( res => {
              // console.log(res)
          } ).catch( res => {
            // console.log(res)
          } )
      }
  }

  async function verifyIfCodeIsCorrect({ emailCode }) {
      const token = await AsyncStorage.getItem('JWT_TOKEN');

      const config = {
          headers: { Authorization: "Bearer " + token }
      }

      // console.log(emailCode.length)

      if ( emailCode.length === 4 ) {
          api.post(
              '/confirmEmail',
              {
                  "confirm_action_code": emailCode
              },
              config
          ).then(res => {
              onVerified(res.data.success)
          }).catch(res => {
              onVerified(res.data.success)
          })
      }
  }

  function change(e) {
    onChange(e)
    if ( e.length == 4 ) {
        verifyIfCodeIsCorrect(e)
    }
  }

  return (<View></View>);
//   return (
//     <View style={{marginTop: 20}}>
//     {
//         countDown==null?
//         <Button title={ "ENVIAR CÓDIGO DE VERIFICAÇÃO" } onPress={() => {
//             setCountDown(60);
//             handleCounter();

//             sendEmailVerification();
//         }} style={{ borderRadius: '10px', color: '#FFFFFF', background: '#999999', fontSize: 14, fontWeight: '700' }} />
//             :
//             <View>
//                 <View>
//                     <AuthCodeInput
//                         style={{display: 'flex', flexDirection: 'column'}}
//                         cellCount={4}
//                         isPassword={true}
//                         // value={emailValue}
//                         onValueChange={(value) => change(value)}
//                         label="Digite o código de verificação enviado:"
//                     />
//                 </View>
//                 {
//                     countDown>1?
//                     <Text>Aguarde {countDown} segundos para reenviar.</Text> :

//                     <Button title={ "enviar" }
//                     onPress={() => {
//                         setCountDown(60)
//                         handleCounter()

//                         sendEmailVerification()
//                     }}
//                     style={{ borderRadius: 10, color: '#FFFFFF', backgroundColor: '#999999', fontSize: 14 }}
//                     ></Button>
//                 }
//             </View>
//     }
// </View>
//  )
}
